/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Get_Instant_AccessInputs */

const en_get_instant_access = /** @type {(inputs: Get_Instant_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Instant Access`)
};

const es_get_instant_access = /** @type {(inputs: Get_Instant_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtener acceso instantáneo`)
};

const fr_get_instant_access = /** @type {(inputs: Get_Instant_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir un accès instantané`)
};

const de_get_instant_access = /** @type {(inputs: Get_Instant_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sofortigen Zugang erhalten`)
};

const ja_get_instant_access = /** @type {(inputs: Get_Instant_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すぐにアクセスを取得`)
};

const zh_get_instant_access = /** @type {(inputs: Get_Instant_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即获取访问权限`)
};

const ar_get_instant_access = /** @type {(inputs: Get_Instant_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احصل على وصول فوري`)
};

const id_get_instant_access = /** @type {(inputs: Get_Instant_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan Akses Instan`)
};

const it_get_instant_access = /** @type {(inputs: Get_Instant_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni Accesso Istantaneo`)
};

const ru_get_instant_access = /** @type {(inputs: Get_Instant_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получить мгновенный доступ`)
};

const pt_get_instant_access = /** @type {(inputs: Get_Instant_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obter Acesso Imediato`)
};

const ko_get_instant_access = /** @type {(inputs: Get_Instant_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`즉시 액세스 권한 얻기`)
};

/**
* | output |
* | --- |
* | "Get Instant Access" |
*
* @param {Get_Instant_AccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const get_instant_access = /** @type {((inputs?: Get_Instant_AccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Get_Instant_AccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_get_instant_access(inputs)
	if (locale === "es") return es_get_instant_access(inputs)
	if (locale === "fr") return fr_get_instant_access(inputs)
	if (locale === "de") return de_get_instant_access(inputs)
	if (locale === "ja") return ja_get_instant_access(inputs)
	if (locale === "zh") return zh_get_instant_access(inputs)
	if (locale === "ar") return ar_get_instant_access(inputs)
	if (locale === "id") return id_get_instant_access(inputs)
	if (locale === "it") return it_get_instant_access(inputs)
	if (locale === "ru") return ru_get_instant_access(inputs)
	if (locale === "pt") return pt_get_instant_access(inputs)
	return ko_get_instant_access(inputs)
});